module.exports = {
    cognitoUserPoolClientId: '31r29ml6m5osdgn8iiphm26a4v',
    cognitoUserPoolId: 'us-east-1_bgHmYj8MW',
    environment: 'dev-upper',
    lowerEnvironment: 'dev-lower',
    restApiEndpoint: 'https://4abjqe6nck.execute-api.us-east-1.amazonaws.com/dev-upper',
    restApiName: 'dev-upper-dsco-ship-codes-ApiStack-M9F02N4J7JQ9'
}
